import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-offic-8",
  "use": "icon-ie-offic-8-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-offic-8\">\n    <path d=\"M431.396571 130.56c35.84-60.269714 125.366857-60.269714 161.206858 0l376.173714 632.685714c35.84 60.269714-8.996571 135.606857-80.603429 135.606857H135.826286c-71.68 0-116.443429-75.337143-80.603429-135.606857l376.100572-632.685714z\" fill=\"#9254DE\" p-id=\"2416\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol